export default "__VITE_ASSET__96a682b5__"